module.exports = new __parcel__URL__("CompanyManaged.a932409f.svg").toString();